
$(document).ready(function(){
	max = parseInt($('.product-info-description .rte').css('max-height'));

	if ($('.product-info-description .rte .inner').height() >= max) {
		console.log("zz");
		$('.product-info-description .rte').append('<div class="gradient"></div>');
		$('.product-info-description-toggle').removeClass('hide-mobile').addClass('show-mobile-inline-block');
	} else {
		$('.product-info-description-toggle').hide();
	}

	$('.product-info-description-toggle').on('click',function(){
		$(this).prev().css({
			'max-height' : 'none'
		});

		$(this).prev().find('.gradient').hide(); 
		$(this).hide(); 
	});

	//-- sticky product images
	$('.product-top.row .images-container').css({
		'position': 'sticky',
		'top': $('header').outerHeight() + 30
	});
});


$(function(){

	var adding = false;
	$("#product-buy").on("click",function(e){
		e.preventDefault();
		t = $(this);
		if(! adding)
		{
			adding= true;
			t.val("Adding to cart");
			args = {quantity:$("#quantity").val(),id:$("#product-select").val()};
			$.ajax({
				type: 'POST',
				url: '/cart/add.js',
				data: args,
				dataType: 'json',
				success:function(line_item){
					refreshCart(true);
					// $(".header-cart").trigger("click");
					t.val("Add to cart");
					adding = false;
				}
			});
		}
	});

	$(".product-form-con").on("click",".product-quantity-panel-plus",function(){
		console.log("yyy");
		q = $(this).prev();
        let max = $(this).attr("data-max")
		$(this).attr("disabled",false);
        if (max != undefined) {
            if (q.val() < max) {
                var value = parseInt(q.val(), 10);
                value = isNaN(value) ? 0 : value;
                value++;
                
                q.val(value)
			}
			else
			{
				$(this).attr("disabled",true);
			}
        }
        else {
            var value = parseInt(q.val(), 10);
            value = isNaN(value) ? 0 : value;
            value++;

            q.val(value);
        }
	});

	$(".product-form-con").on("click",".product-quantity-panel-minus",function(){
		q = $(this).next();

		q.next().attr("disabled",false);
		var value = parseInt(q.val(), 10);
		value = isNaN(value) ? 1 : value;
		if(value > 0)
		{
			value--;
			q.val(value);
		}

	});
});